import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Headsetsvg } from 'images/headset.svg';
import Paper from './Paper';

const ContactCustomerServiceContainer = styled.div`
  .content-wrapper {
    display: flex;
    align-items: center;
    h2 {
      flex-grow: 1;
    }
  }
  a {
    color: ${({ theme }) => theme.palette.colors.green1};
    font-size: 1.2rem;
    text-decoration: none;
  }
`;

const ImageWrapper = styled.div`
  text-align: center;
  svg {
    height: 104px;
    width: auto;
  }
`;

const ContactCustomerService = ({ className, header, phoneNumber }) => {
  const classes = ['contactCustomerService'];
  if (className) classes.push(className);
  return (
    <ContactCustomerServiceContainer className={classes.join(' ')}>
      <Paper>
        <div className="content-wrapper">
          <h2>{header}</h2>
          <ImageWrapper>
            <Headsetsvg />
          </ImageWrapper>
        </div>
        <a href={`tel:${phoneNumber}`}>
          Call&nbsp;
          {phoneNumber}
        </a>
      </Paper>
    </ContactCustomerServiceContainer>
  );
};

export default ContactCustomerService;

ContactCustomerService.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  phoneNumber: PropTypes.string.isRequired,
};

ContactCustomerService.defaultProps = {
  className: null,
  header: 'Please contact customer service',
};
